import React from 'react'
import { createIcon } from '@chakra-ui/icon'

export const PauseIcon = createIcon({
  displayName: 'PauseIcon',
  path: <path fillRule="evenodd" clipRule="evenodd" d="M10 19H6V5H10V19ZM14 19V5H18V19H14Z" fill="currentColor" />,
  viewBox: '0 0 24 24',
})
